/* eslint-disable react-hooks/exhaustive-deps */
import { Path } from "@common/constans";
import { IExtLocation } from "@common/models";
import { IMarker } from "@common/models/CMS/Marker";
import { IMarkerGroup } from "@common/models/CMS/MarkerGroup";
import Button from "@components/general/form/Button";
import { hideGoogleMarkerInfoWindow, showGoogleMarkerInfoWindow } from "@components/general/GoogleMap";
import Icon from "@components/general/Icon";
import OptimizedImage from "@components/general/OptimizedImage";
import Search from "@components/Search";
import { getFilePath } from "@config/appConfig";
import Translate from "@service/Translate";
import { forwardRef, Fragment, useContext, useEffect, useRef, useState } from "react";
import { useHistory } from "react-router";
import CardItem from "../CardItem";
import CardWidgetController from "../CardWidgetController";
import WidgetContainer from "../WidgetContainer";
import { MapWidgetAction } from "./MapWidgetAction";
import { MapWidgetContext } from "./MapWidgetContext";

interface IMapWidgetProps {
    markersWithContents: IMarker[];
}


export const SearchSection = forwardRef<HTMLLIElement, IMapWidgetProps>(
    ({ markersWithContents }, ref) => {
        const { push } = useHistory();
        const { tr } = Translate;
        const currentSearchItem = useRef<HTMLDivElement>(null);
        const { state: { dataSource, markerGroups, selectedMarkerGroups, mapMarkers, currentMarker }, dispatch } = useContext(MapWidgetContext);
        const [expandSearchSection, setExpandSearchSection] = useState<boolean>(false);
        const [searchTerm, setSearchTerm] = useState<string>("");
        const [onSearchItemClicked, setOnSearchItemClicked] = useState<boolean>(false);

        useEffect(() => {
            if (currentMarker?.contentItemId) {
                setExpandSearchSection(true);
            }
        }, [currentMarker])

        const onSearchFocusClick = () => {
            hideGoogleMarkerInfoWindow(currentMarker?.contentItemId || "");
            dispatch({ type: MapWidgetAction.CurrentMarker, payload: { currentMarker: {} } });
            setExpandSearchSection(true);
        }

        const onSearchItemClick = (marker: IMarker) => {
            setOnSearchItemClicked(true);
            setTimeout(() => {
                currentSearchItem?.current?.scrollIntoView({ block: "start", inline: "start", behavior: "smooth" });
            }, 100);
            const mapMarker: IExtLocation = mapMarkers.find(x => x.id === marker.contentItemId) || {} as IExtLocation;
            if (!mapMarker) {
                const markerGroup: IMarkerGroup = markerGroups?.find(markerGroup => markerGroup?.markers?.contentItems?.some(x => x.contentItemId === marker.contentItemId)) || {};
                mapMarkers.push({
                    id: marker.contentItemId,
                    icon: getFilePath(marker.icon?.paths[0] ?? markerGroup.defaultMarkerIcon?.paths[0]),
                    lat: marker.location?.latitude as number,
                    lng: marker.location?.longitude as number,
                    tooltip: marker.tooltip,
                    tooltipDisplayMode: marker.tooltipDisplayMode,
                })
            }
            else {
                mapMarker.opacity = 1;
            }
            dispatch({ type: MapWidgetAction.MapMakers, payload: { mapMarkers: mapMarkers.slice() } });
            dispatch({ type: MapWidgetAction.CurrentMarker, payload: { currentMarker: marker } })
        }

        const onBackwardBtnClick = () => {
            hideGoogleMarkerInfoWindow(currentMarker?.contentItemId || "");
            const markerGroup: IMarkerGroup = selectedMarkerGroups?.find(markerGroup => markerGroup?.markers?.contentItems?.some(x => x.contentItemId === currentMarker?.contentItemId)) || {};
            if (selectedMarkerGroups.length && !markerGroup.markers?.contentItems.some(x => x.contentItemId === currentMarker?.contentItemId) && mapMarkers.some(x => x.id === currentMarker?.contentItemId))
                mapMarkers.splice(mapMarkers.findIndex(x => x.id === currentMarker?.contentItemId));
            if (currentMarker?.contentItemId && onSearchItemClicked) {
                setOnSearchItemClicked(false);
            }
            else {
                setExpandSearchSection(false);
                setSearchTerm("");
            }
            setTimeout(() => {
                dispatch({ type: MapWidgetAction.CurrentMarker, payload: { currentMarker: {} } });
            }, 250)
            dispatch({ type: MapWidgetAction.MapMakers, payload: { mapMarkers: mapMarkers.slice() } })
        }

        const attractionItems: IMarker[] = markerGroups.flatMap(markerGroup => markerGroup.markers?.contentItems.filter(x => x.tooltip?.html.toLowerCase().indexOf(searchTerm.toLowerCase()) !== -1) || {});

        return (
            <div className={`search-section ${expandSearchSection ? "expand" : ""} ${currentMarker?.contentItemId ? "show-current-search-item" : ""}`}>
                <div
                    ref={currentSearchItem}
                    className="search-section-wrapper">
                    <div className="search-container flex flex-center">
                        <Icon
                            color="grey"
                            className="icon-backward"
                            name="icon-chevron-right"
                            size="36px"
                            flip
                            onClick={onBackwardBtnClick}
                        />
                        <Search
                            className="flex-grow"
                            value={searchTerm}
                            autoComplete="off"
                            onFocus={onSearchFocusClick}
                            onValueChange={(term) => setSearchTerm(term)}
                            placeHolder={tr("search")}
                        />
                    </div>
                </div>
                {
                    currentMarker?.contentItemId ?
                        <div
                            ref={currentSearchItem}
                            className="current-search-item" >
                            {
                                currentMarker?.tag === "Custom" ?
                                    <WidgetContainer
                                        generalContainer={markersWithContents.find(x => x.contentItemId === currentMarker?.contentItemId)}
                                    />
                                    :
                                    <Fragment>
                                        <div className="cover">
                                            <OptimizedImage source={currentMarker?.content?.cover || {}} />
                                        </div>
                                        <div className="container">
                                            <div className="title mt-4"
                                                dangerouslySetInnerHTML={{ __html: currentMarker?.tooltip?.html as string }}
                                            />
                                            <div
                                                className="introduction"
                                                dangerouslySetInnerHTML={{ __html: currentMarker?.content?.introduction?.html }}
                                            />
                                        </div>
                                        <div className="more-btn button-group">
                                            <Button
                                                height="40px"
                                                className="show-on-map-btn"
                                                iconPositin="end"
                                                icon="icon-location-on-map"
                                                variant="contained"
                                                color="blue"
                                                text={tr("map")}
                                                onClick={() => setExpandSearchSection(false)}
                                            />
                                            <Button
                                                height="40px"
                                                iconPositin="end"
                                                icon="icon-arrow-right"
                                                variant="contained"
                                                color="blue"
                                                type="more-info"
                                                text={tr("more_info")}
                                                onClick={() => push(`${Path.Tourism.AttractionDetail}/${currentMarker?.contentItemId}`)}
                                            />
                                        </div>
                                    </Fragment>
                            }
                        </div>
                        :
                        <ul className="search-items">
                            {
                                attractionItems.length ?
                                    attractionItems.map((marker, index) =>
                                        <li
                                            key={index}
                                            ref={ref}
                                            className="search-item"
                                            onClick={() => onSearchItemClick(marker)}
                                            onMouseEnter={() => showGoogleMarkerInfoWindow(marker.contentItemId || "")}
                                            onMouseLeave={() => !currentMarker?.contentItemId && hideGoogleMarkerInfoWindow(marker.contentItemId || "")}
                                        >
                                            {
                                                markersWithContents.find(x => x.contentItemId === marker.contentItemId) ?
                                                    <WidgetContainer
                                                        generalContainer={markersWithContents.find(x => x.contentItemId === currentMarker?.contentItemId)}
                                                    />
                                                    :
                                                    <CardItem
                                                        card={{
                                                            displayText: dataSource.find(x => x.localization?.localizationSet === marker.contentItemId)?.displayText,
                                                            //image: marker?.content?.cover,
                                                            tags: [tr(marker.tag?.toLowerCase() || "")]
                                                        }}
                                                        cardWidgetController={new CardWidgetController({ style: 'style4' })}
                                                    />
                                            }
                                        </li>
                                    )
                                    : <li className="search-item not-found">{tr("no_record")}</li>
                            }
                        </ul>
                }
            </div>
        )
    }
)

export default SearchSection;